import type React from "react";
import {useEffect, useState} from "react";

import {NormalBlending, type Texture, TextureLoader} from "three";

import {useUniforms} from "~/contexts/uniforms/Uniforms";
import {cld} from "~/firebase/cloudinary";

import fragmentShaderTexture from "./circle.frag?raw";
import vertexShader from "./circle.vert?raw";

const CircleInstanceDefinition: React.FC = () => {
  const [texture, setTexture] = useState<Texture | null>(null);
  const uniforms = useUniforms();

  // Load texture using useEffect and update state
  useEffect(() => {
    const loader = new TextureLoader();
    loader.load(
      cld
        .image("texture_atlas_circle_fwbu8y")
        .format("auto")
        .quality("auto")
        .toURL(),
      (loadedTexture) => {
        setTexture(loadedTexture);
      },
    );
  }, []);
  // Provide a fallback material while the texture is loading
  if (!texture) {
    return <meshBasicMaterial color="lightGray" attach="material" />;
  }

  return (
    <shaderMaterial
      vertexShader={vertexShader}
      fragmentShader={fragmentShaderTexture}
      uniforms={{
        ...uniforms,
        uTexture: {value: texture},
      }}
      transparent={true}
      blending={NormalBlending}
      attach="material"
    />
  );
};

export default CircleInstanceDefinition;
